import {createPortal} from 'react-dom'
import type {ReactNode} from 'react'

/**
 * Всё, что лежит поверх страницы: просмотр снимка, модальные окна.
 *
 * Рисуем в корне документа, а не там, где написано в разметке. Причина
 * не в красоте: страницы у нас `position: fixed`, а фиксированный элемент
 * создаёт КОНТЕКСТ НАЛОЖЕНИЯ. Значит z-index оверлея действует только
 * внутри своей страницы, и левая рейка — она в корневом контексте — молча
 * рисуется поверх. Проявилось это тем, что метки людей в панели снимка
 * оказались наполовину под рейкой.
 *
 * Поднимать z-index бесполезно: контексты сравниваются целиком, а не по
 * содержимому. Единственное надёжное средство — вынести оверлей из
 * страницы наружу.
 */
export default function Overlay({children}: {children: ReactNode}) {
  return createPortal(children, document.body)
}
